import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface FallbackProps {
  error: unknown
  componentStack: string | null
  eventId: string | null
  resetError: () => void
}

export function SentryErrorFallback({ eventId, resetError }: FallbackProps) {
  return (
    <div className='flex min-h-screen items-center justify-center bg-background p-4'>
      <div className='w-full max-w-md space-y-6 text-center'>
        <div className='flex justify-center'>
          <AlertTriangle className='h-16 w-16 text-destructive' />
        </div>
        <div className='space-y-2'>
          <h1 className='text-2xl font-bold text-foreground'>Algo deu errado</h1>
          <p className='text-muted-foreground'>
            Ocorreu um erro inesperado. Nossa equipe foi notificada e estamos trabalhando para resolver.
          </p>
        </div>
        <div className='flex flex-col gap-3 sm:flex-row sm:justify-center'>
          <Button variant='outline' onClick={resetError}>
            Tentar novamente
          </Button>
          <Button onClick={() => (window.location.href = '/')}>Voltar ao inicio</Button>
        </div>
        {eventId && (
          <p className='text-xs text-muted-foreground'>
            ID do erro: <code className='rounded bg-muted px-1 py-0.5'>{eventId}</code>
          </p>
        )}
      </div>
    </div>
  )
}
